import React, { PropsWithChildren, useEffect, useState } from 'react';
import { ThemeContext } from '../models/ThemeContext';
import {
    getThemeFromLocalStorage,
    setThemeInLocalStorage,
} from '../../Common/util/localStorageUtils';
import { darkTheme } from '../styles/darkTheme';
import { defaultTheme } from '../styles/defaultTheme';

interface IThemeContextProviderProps extends PropsWithChildren<any> {}

export const ThemeContextProvider: React.FC<IThemeContextProviderProps> = (
    props: IThemeContextProviderProps
) => {
    const [themeName, setTheme] = useState(getThemeFromLocalStorage());

    //change theme in localStorage if user changes it
    useEffect(() => {
        if (getThemeFromLocalStorage() !== themeName) {
            setThemeInLocalStorage(themeName);
        }
    }, [themeName]);

    // Sync dark mode class and body styles so plain CSS and non-Fluent elements respond to theme
    useEffect(() => {
        const theme = themeName === 'dark' ? darkTheme : defaultTheme;
        if (themeName === 'dark') {
            document.body.classList.add('theme-dark');
        } else {
            document.body.classList.remove('theme-dark');
        }
        document.body.style.backgroundColor = theme.surfaces.appBackground;
        document.body.style.color = theme.semanticColors.bodyText;
    }, [themeName]);

    return (
        <ThemeContext.Provider
            value={{ themeName: themeName, setTheme: setTheme }}
        >
            {props.children}
        </ThemeContext.Provider>
    );
};
